import { Box, Grid, HStack, Text, useColorModeValue } from '@chakra-ui/react';
import type { Country } from '@/models/country';
import { FIXTURE_MATCH_CHEVRON_COLUMN } from '../FixtureMatchRow';
import { Flag } from '../Flag';

function formatPoints(points: number): string {
  return `+${points}`;
}

export function MatchPointsRow(props: {
  homeTeam: Country;
  awayTeam: Country;
  homePoints: number;
  awayPoints: number;
  gridColumns: string;
  columnGap: number | string;
  svg?: boolean;
  includeChevronSpacer?: boolean;
}) {
  const labelColor = useColorModeValue('gray.600', 'gray.400');
  const pointsColor = useColorModeValue('gray.700', 'gray.200');
  const separatorColor = useColorModeValue('gray.500', 'gray.500');

  return (
    <Grid
      templateColumns={props.gridColumns}
      columnGap={props.columnGap}
      alignItems='center'
      w='full'
      fontSize='xs'
      lineHeight='short'
    >
      <Text gridColumn='1 / 3' color={labelColor} textAlign='left'>
        Points:
      </Text>
      <HStack gridColumn={3} justify='center' spacing={1.5} whiteSpace='nowrap'>
        <Flag
          country={props.homeTeam}
          w={4}
          h={3}
          borderRadius='2px'
          flexShrink={0}
          svg={props.svg}
        />
        <Text fontWeight='semibold' color={pointsColor}>
          {formatPoints(props.homePoints)}
        </Text>
        <Text color={separatorColor}>-</Text>
        <Text fontWeight='semibold' color={pointsColor}>
          {formatPoints(props.awayPoints)}
        </Text>
        <Flag
          country={props.awayTeam}
          w={4}
          h={3}
          borderRadius='2px'
          flexShrink={0}
          svg={props.svg}
        />
      </HStack>
      {props.includeChevronSpacer ? (
        <Box
          gridColumn={6}
          aria-hidden
          w={FIXTURE_MATCH_CHEVRON_COLUMN}
          minW={FIXTURE_MATCH_CHEVRON_COLUMN}
        />
      ) : null}
    </Grid>
  );
}
